<template>
   <vx-card no-shadow>
       <h4>Opening Hours</h4>
       <h6>Configure school week settings here by moving the sliders</h6>
       <div class="flex flex-wrap p-3" v-for="field in schedule" :key="field.day"> 
           <div class="inline-flex items-center md:w-1/5 w-full">
              <vs-switch v-model="field.is_active" />           
              <span class="mx-2">{{field.day}}</span>
            </div>
             <div class="md:w-4/5 w-full">
                 <vs-slider :disabled="field.is_active==false?true:false" :min="9" step="1" :max="20" text-fixed=":00"  v-model="field.time"/>
             </div>

       </div>

       <vs-button type="filled" @click="scheduleChange">Update</vs-button>
      <!-- <div class="cstm_vuexy_table">
        <table>
          
            <tr>
              <th>
                Holidays
              </th>
              <td>
                pujo
              </td>
              <td>
                kali pujo
              </td>
              <td>
                <span class="material-icons">
                more_vert
                </span>
              </td>
            </tr>
         
        </table>
      </div> -->
        
   </vx-card>
</template>

<script>
import {scheduleTimeApi, fetchScheduleApi} from '@/api/generalapi'

export default {
  data () {
    return {
      customer_id:'',
      schedule:[
        {
          day:'Monday',
          time:[9, 20],
          is_active:false
        },
        { 
          day:'Tuesday',
          time:[9, 20],
          is_active:false
        },
        { 
          day:'Wednesday',
          time:[9, 20],
          is_active:false
        },
        { 
          day:'Thursday',
          time:[9, 20],
          is_active:false
        },
        { 
          day:'Friday',
          time:[9, 20],
          is_active:false
        }, { 
          
          day:'Saturday',
          time:[9, 20],
          is_active:false
        },
        { 
          day:'Sunday',
          time:[9, 20],
          is_active:false
        }

      ]
    }
  },
  mounted () {
    this.customer_id = localStorage.getItem('customer_id')
    this.fetchSchedule()
  },
  
  methods: {
    async fetchSchedule () {

      const data = await fetchScheduleApi(this.customer_id)
      const res = data.data.data.fetchUserScheduleSetting
      let i = 0
      if (res.length > 0) {
        for (i = 0; i < res.length; i++) {
          this.schedule[i].is_active = res[i].is_active
          this.schedule[i].time = [res[i].start_time, res[i].end_time]
        }
      }
     
      
      console.log(res)
    },
    async scheduleChange () {
    
      const payload = {
        updateField:{
          customer_id:this.customer,
          schedule:this.schedule
        }
      }
      const data = await scheduleTimeApi(this.customer_id, payload)
      this.showSuccessMessage('Success', 'Schedule updated Successfully', 'success')
      console.log(data)
    }
  }
}
</script>

<style>

</style>